import React, { useMemo } from 'react';

import * as styles from './styles';
import { IconButton } from '@material-ui/core';

import Button from '@cobliteam/ui/components/Button';

import ClearRoundedIcon from '@material-ui/icons/ClearRounded';

import type { AlertConfigCTA } from '../AlertItem';

interface AlertRightContentProps {
  cta?: AlertConfigCTA;
  hasCloseBtn: boolean;
  hoverColor: string;
  classes?: {
    closeIcon?: string;
  };
  handleCloseAlert: () => void;
}

export const AlertRightContent: React.FC<AlertRightContentProps> = React.memo(
  ({ cta, hasCloseBtn, hoverColor, classes = {}, handleCloseAlert }: any) => {
    const ctaBtn = useMemo(() => {
      if (cta) {
        return (
          <Button
            variant='text'
            color='success'
            className='mx-2.5 underline'
            onClick={cta.callback}
          >
            {cta.text}
          </Button>
        );
      }

      return null;
    }, [cta]);

    const closeBtn = useMemo(() => {
      if (!hasCloseBtn) {
        return null;
      }

      return (
        <IconButton
          title='fechar'
          className={styles.alertCloseButtonClass(hoverColor)}
          onClick={handleCloseAlert}
        >
          <ClearRoundedIcon />
        </IconButton>
      );
    }, [hasCloseBtn]);

    return (
      <div className={`${styles.rightSideWrapper} ${classes.closeIcon}`}>
        {ctaBtn}
        {closeBtn}
      </div>
    );
  }
);
